/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ProviderAccount/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import AccountId from './AccountId/index'
import AccountLocations from './AccountLocations/index'
import AccountToken from './AccountToken/index'
import AcknowledgePlatformFee from './AcknowledgePlatformFee/index'
import Actions from './Actions/index'
import ApproveAction from './ApproveAction/index'
import DefaultAction from './DefaultAction/index'
import DefaultPaymentProvider from './DefaultPaymentProvider/index'
import InvalidateAction from './InvalidateAction/index'
import LastChanges from './LastChanges/index'
import ParentCompany from './ParentCompany/index'
import PaypointName from './PaypointName/index'
import Provider from './Provider/index'
import React from 'react'
import RejectAction from './RejectAction/index'
import Settings from './Settings/index'
import Status from './Status/index'
import TysiaCard from 'DesignSystem/TysiaCard/index'
import TysiaCardContent from 'DesignSystem/TysiaCard/TysiaCardContent/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ProviderAccount({
  children,
  viewPath = "/App/Account/Content/Settings/Content/PaymentProviders/Accounts/Content/ProviderAccount"
  
}) {
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let providerAccountProviderValueData = fromData.useDataValue({ viewPath,
context: 'provider_account',
path: 'provider',
})
let constantData = 'payabli'
let aggregateData = fromAggregate.equals(providerAccountProviderValueData, constantData)
let providerAccountHasChangesValueData = fromData.useDataValue({ viewPath,
context: 'provider_account',
path: 'has_changes',
})
  return (<React.Fragment
>
<TysiaCard
  viewPath={`${viewPath}/TysiaCard`}
 flexGrow={1}
 flexShrink={1}
 flexBasis="100%"
 borderColor={dtColorsNeutral200}
>
{childProps => (
<TysiaCardContent
{...childProps}
  viewPath={`${viewPath}/TysiaCardContent`}
 overflowX="hidden"
 overflowY="hidden"
>
{childProps => (
<div
  data-testid="ProviderAccount.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="ProviderAccount.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="ProviderAccount.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<Provider
  viewPath={`${viewPath}/Provider`}
/>
<DefaultPaymentProvider
  viewPath={`${viewPath}/DefaultPaymentProvider`}
/>
<Status
  viewPath={`${viewPath}/Status`}
/>
</div>
<div
  data-testid="ProviderAccount.Horizontal:2"
  data-view-path={viewPath}
 style={{'--g-1-Z3OJc6': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal2}`}
>
<ApproveAction
  viewPath={`${viewPath}/ApproveAction`}
/>
<RejectAction
  viewPath={`${viewPath}/RejectAction`}
/>
<DefaultAction
  viewPath={`${viewPath}/DefaultAction`}
/>
<InvalidateAction
  viewPath={`${viewPath}/InvalidateAction`}
/>
</div>
</div>
<div
  data-testid="ProviderAccount.Vertical:1"
  data-view-path={viewPath}
 style={{'--g-1-Z3OJc6': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--mt-2-Z3OJc6': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="ProviderAccount.Horizontal:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal3}`}
>
<AccountId
  viewPath={`${viewPath}/AccountId`}
/>
<AccountToken
  viewPath={`${viewPath}/AccountToken`}
/>
</div>
<fromFlow.When is={aggregateData}>
<div
  data-testid="ProviderAccount.Horizontal:4"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal4}`}
>
<PaypointName
  viewPath={`${viewPath}/PaypointName`}
/>
<ParentCompany
  viewPath={`${viewPath}/ParentCompany`}
/>
</div>
</fromFlow.When>
<div
  data-testid="ProviderAccount.Horizontal:5"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal5}`}
>
<AccountLocations
  viewPath={`${viewPath}/AccountLocations`}
/>
</div>
</div>
<Settings
  viewPath={`${viewPath}/Settings`}
/>
<div
  data-testid="ProviderAccount.Horizontal:6"
  data-view-path={viewPath}
 style={{'--mt-2-Z3OJc6': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--jc-3-Z3OJc6': providerAccountHasChangesValueData ? "space-between" : "flex-end"}}
 className={`views-block ${styles.Horizontal6}`}
>
<Actions
  viewPath={`${viewPath}/Actions`}
/>
<LastChanges
  viewPath={`${viewPath}/LastChanges`}
/>
</div>
</div>
)}
</TysiaCardContent>
)}
</TysiaCard>
<AcknowledgePlatformFee
  viewPath={`${viewPath}/AcknowledgePlatformFee`}
/>
{children}
</React.Fragment>)
}